/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FarmacoPacienteDto } from '../../models/farmaco-paciente-dto';

export interface FarmacosControllerActualizarFarmacoPacienteFarmaciaHospitalaria$Params {
  farmacoUuid: string;
      body: FarmacoPacienteDto
}

export function farmacosControllerActualizarFarmacoPacienteFarmaciaHospitalaria(http: HttpClient, rootUrl: string, params: FarmacosControllerActualizarFarmacoPacienteFarmaciaHospitalaria$Params, context?: HttpContext): Observable<StrictHttpResponse<FarmacoPacienteDto>> {
  const rb = new RequestBuilder(rootUrl, farmacosControllerActualizarFarmacoPacienteFarmaciaHospitalaria.PATH, 'put');
  if (params) {
    rb.path('farmacoUuid', params.farmacoUuid, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FarmacoPacienteDto>;
    })
  );
}

farmacosControllerActualizarFarmacoPacienteFarmaciaHospitalaria.PATH = '/api/farmacos/farmacos-paciente-farmacia-hospitalaria/{farmacoUuid}';
